import { injectIntl } from '@atlassian/jira-intl/src/index.tsx';
import QueueProvider from './main.tsx';

export default injectIntl(QueueProvider);
